import { UpdateUserInfoModel } from "@truckdown/accounts";
import { IValidator } from "../../Validation/IValidator";

interface IPropertyValidator {
    key: string;
    validator: () => boolean;
    message: () => string;
}

export class UserValidator implements IValidator {
    constructor(user: UpdateUserInfoModel) {
        this._user = user;
        this._validators = this.getValidators();
    }

    private _user: UpdateUserInfoModel;
    private _validators: IPropertyValidator[];
    private getValidators(): IPropertyValidator[] {
        return [
            {
                key: "firstName",
                message: () => this.validateUserFirstNameMessage(this._user.firstName),
                validator: () => this.validateUserFirstName(this._user.firstName)
            },
            {
                key: "lastName",
                message: () => this.validateUserLastNameMessage(this._user.lastName),
                validator: () => this.validateUserLastName(this._user.lastName)
            },
            {
                key: "home",
                message: () => this.validateUserPhoneMessage(this._user.home),
                validator: () => this.validateUserPhone(this._user.home)
            },
            {
                key: "office",
                message: () => this.validateUserOfficePhoneMessage(this._user.office),
                validator: () => this.validateUserOfficePhone(this._user.office)
            },
            {
                key: "fax",
                message: () => this.validateUserPhoneMessage(this._user.fax),
                validator: () => this.validateUserPhone(this._user.fax)
            }
        ];
    }

    private validateUserFirstNameMessage(firstName: string): string {
        if (!firstName || firstName.trim().length < 1) {
            return "First Name is required.";
        }
        return "";
    }

    private validateUserFirstName(firstName: string): boolean {
        let isValid = false;
        if (firstName && firstName.trim().length > 0) {
            isValid = true;
        }

        return isValid;
    }

    private validateUserLastNameMessage(lastName: string): string {
        if (!lastName || lastName.trim().length < 1) {
            return "Last Name is required.";
        }
        return "";
    }

    private validateUserLastName(lastName: string): boolean {
        let isValid = false;
        if (lastName && lastName.trim().length > 0) {
            isValid = true;
        }

        return isValid;
    }

    private validateUserOfficePhoneMessage(phone: string | undefined): string {
        if (!phone || phone.trim().length < 1) {
            return "Office Phone is required."
        }
        const phoneRegex = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;

        const match = phoneRegex.exec(phone);

        if (!match) {
            return "Invalid phone number or format.  Please use format xxx xxx xxxx.";
        }

        return "";
    }

    private validateUserOfficePhone(phone: string | undefined): boolean {
        if (!phone || phone.trim().length == 0) {
            return false;
        }

        return this.validatePhone(phone);
    }

    private validateUserPhoneMessage(phone: string | undefined): string {
        if (phone && phone.trim().length > 0) {
            const phoneRegex = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;

            const match = phoneRegex.exec(phone);

            if (!match) {
                return "Invalid phone number or format.  Please use format xxx xxx xxxx.";
            }
        }

        return "";
    }

    private validateUserPhone(phone: string | undefined): boolean {
        if (!phone || phone.trim().length == 0) {
            return true;
        }

        return this.validatePhone(phone);
    }

    private validatePhone(phone: string): boolean {
        const phoneRegex = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;

        const match = phoneRegex.exec(phone);

        if (match) {
            return true;
        } else {
            return false;
        }
    }

    validate(key?: string): boolean {
        if (key) {
            let validator = this._validators.find(v => v.key == key);
            if (validator) {
                const isValid = validator.validator();
                if (!isValid) {
                    this.errors[key] = validator.message();
                } else {
                    delete this.errors[key];
                }
                return isValid;
            }
            return true;
        } else {
            let isValid = true;
            for (let i = 0; i < this._validators.length; i++) {
                let v = this._validators[i];
                if (!v.validator()) {
                    isValid = false;
                    delete this.errors[v.key];
                    this.errors[v.key] = v.message();
                } else {
                    delete this.errors[v.key];
                }
            }
            return isValid;
        }
    }

    reset() {
        this.errors = {};
    }

    errors: { [key: string]: string } = {};
}